require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./courses-code-501-computational-thinking-for-educators.json") })
        }
      }, "path---courses-code-501-computational-thinking-for-educators");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---courses-code-501-computational-thinking-for-educators!./.cache/json/courses-code-501-computational-thinking-for-educators.json
// module id = 1181
// module chunks = 231608221292675